import { jsx as _jsx } from "react/jsx-runtime";
import { skipToken } from "@madmedical/store";
import { CallCenterDeviceModalForm, Modal } from "@madmedical/ui";
import { ApiFormWrapper } from "@madmedical/form";
import { adaptPatient, useGetInstitutionsQuery, useGetPatientsQuery, } from "@madmedical/user";
import { DeviceOperation } from "@madmedical/medical";
import { useGetLogisticsDeviceQuery, useUpdateDeviceMutation } from "./api";
import resolveValidOperations from "./resolveValidOperations";
const UpdateDeviceForm = ({ id, open, onClose }) => {
    const { data: device } = useGetLogisticsDeviceQuery(open ? id : skipToken);
    const [updateDevice, { isLoading: isSubmitting }] = useUpdateDeviceMutation();
    const { data: patientData } = useGetPatientsQuery({ pageSize: 5000 }); // TODO: Autocomplete
    const { data: institutions } = useGetInstitutionsQuery();
    if (!device) {
        return null;
    }
    return (_jsx(Modal, Object.assign({ open: open, onClose: onClose }, { children: _jsx(ApiFormWrapper, Object.assign({ defaultValues: device, mutation: (value) => updateDevice(Object.assign(Object.assign({}, value), { serialNumber: `${value.serialNumber}\u200B` })) }, { children: ({ submitForm, isSuccess }) => {
                var _a;
                return (_jsx(CallCenterDeviceModalForm, { operations: device
                        ? resolveValidOperations(device.status)
                        : [DeviceOperation.Update], patients: (_a = patientData === null || patientData === void 0 ? void 0 : patientData.items) === null || _a === void 0 ? void 0 : _a.map(adaptPatient), institutions: institutions, onClose: onClose, onSubmitPress: submitForm, isSuccess: isSuccess, isSubmitting: isSubmitting }));
            } })) })));
};
export default UpdateDeviceForm;
